import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ActionHistoryEntry {
    id: number;
    email_id: number;
    content: string;
    user_id: number | null;
    user_name: string;
    created_at: string;
    updated_at: string;
}

export interface ActionHistoryDialogData {
    subject: string;
    action_history: ActionHistoryEntry[];
}

@Component({
    selector: 'app-action-history-dialog',
    templateUrl: './action-history-dialog.component.html',
    styleUrls: ['./action-history-dialog.component.scss']
})
export class ActionHistoryDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<ActionHistoryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ActionHistoryDialogData
    ) { }

    ngOnInit(): void { }

    closeDialog(): void {
        this.dialogRef.close();
    }

    getActionIcon(content: string): string {
        const lower = content.toLowerCase();
        if (lower.includes('preluat') && !lower.includes('nepreluat')) return 'play_circle';
        if (lower.includes('nepreluat')) return 'pause_circle';
        if (lower.includes('șters') || lower.includes('sters')) return 'delete';
        if (lower.includes('redirecționat') || lower.includes('redirectionat')) return 'forward';
        if (lower.includes('răspuns') || lower.includes('raspuns')) return 'reply';
        if (lower.includes('înregistrat') || lower.includes('inregistrat')) return 'assignment_turned_in';
        if (lower.includes('actualizat')) return 'edit';
        return 'info';
    }

    getActionClass(content: string): string {
        const lower = content.toLowerCase();
        if (lower.includes('preluat') && !lower.includes('nepreluat')) return 'action--taken';
        if (lower.includes('nepreluat')) return 'action--untaken';
        if (lower.includes('șters') || lower.includes('sters')) return 'action--deleted';
        if (lower.includes('redirecționat') || lower.includes('redirectionat')) return 'action--redirected';
        if (lower.includes('răspuns') || lower.includes('raspuns')) return 'action--replied';
        if (lower.includes('înregistrat') || lower.includes('inregistrat')) return 'action--registered';
        return 'action--default';
    }
}